// Facts every 3D printing process page shares. Prices and terms come from
// .seo/truth.md only: 3D printing from about $30 for a simple print from a
// ready file, 3D modeling and 3D scanning from $250, no setup fee, studios in
// Glendale, Queens and Brooklyn by appointment, shipping to all 50 states
// (next-day shipping available), NYC courier delivery. Anything else is
// quoted per project.
const { pricing } = require('../printing-service')

const photoRoot = 'https://images.ctfassets.net/dovsnf6qrcem'
const reviewedDate = '2026-11-04'

const studios =
  'Glendale, Queens and Brooklyn, New York. Visits and pickup by appointment.'
const delivery =
  'Shipping to all 50 states (next-day shipping available), courier delivery in NYC, or pickup by appointment'
const files = 'STL, OBJ, STEP, STP or 3DM. No file? Photos or a sketch.'
const noFile = `3D modeling from $${pricing.modelingFrom}; 3D scanning from $${pricing.scanningFrom}`

// Hobby and resale buyers pay less elsewhere; production buyers stay.
const hobby =
  'Hobby prints and parts you plan to resell: a professional studio costs more, so a marketplace or a hobbyist will usually be cheaper.'

const quoteSteps = [
  {
    title: 'Send your file',
    body: 'Open the quote planner, upload your 3D file or photos and tell us the size, quantity, finish and deadline. Files up to 500 MB each are fine.',
  },
  {
    title: 'Get a written quote',
    body: 'A person checks the file and replies with a price, a process and a schedule. If the file needs repair or modeling, the quote says so.',
  },
]

const handoffStep = {
  title: 'Ship or pick up',
  body: 'We ship to all 50 states, next-day if you need it, send it by courier in NYC, or you pick up by appointment at the studio named in your quote.',
}

module.exports = {
  pricing,
  photoRoot,
  reviewedDate,
  studios,
  delivery,
  files,
  noFile,
  hobby,
  quoteSteps,
  handoffStep,
}
